import React from 'react';
import { ScrapbookFile } from '@/api';
import AIIcon from '@/assets/ai.svg';

interface StylusAiItemProps {
  file: ScrapbookFile;
  selected: boolean;
  viewMode?: 'grid' | 'list';
}

const StylusAiItem = ({ file, selected, viewMode = 'grid' }: StylusAiItemProps) => {
  const content = typeof file.content === 'string' ? JSON.parse(file.content) : file.content;
  const response = content?.response;

  // Extract clean text from response
  const firstResponse = Array.isArray(response) ? response[0] : response;
  const query = firstResponse?.content || firstResponse?.question || 'AI Generated Content';

  if (viewMode === 'list') {
    return (
      <div className="flex h-[160px] cursor-pointer items-center gap-4 border border-gray-200 bg-white">
        <div className="inset-4 flex h-full w-[315px] flex-col border-r border-gray-300 bg-gray-50 pt-[7px] pr-0 pb-0 pl-[11px]">
          <AIIcon className="h-8 w-8" />
          <div className="overflow-hidden text-sm">{query}</div>
        </div>
        <div className="relative bottom-10 flex-1">
          <h4 className="font-bold">Stylus AI</h4>
          <div className="mt-1 text-xs text-black"></div>
        </div>
      </div>
    );
  }

  return (
    <div draggable="true" className="draggable-item">
      <div className={`item ${selected ? 'sel' : 'unsel'}`}>
        <div className="cmp">
          <div
            className="cntr relative flex h-0 w-full cursor-pointer items-center justify-center overflow-hidden border border-b-0 border-gray-300 bg-gray-50 pt-[30px]"
            style={{ paddingBottom: '73.25%' }}
          >
            <div className="absolute inset-4 flex flex-col items-start">
              <AIIcon className="mb-2 h-8 w-8" />
              <div className="overflow-hidden text-center text-sm">{query}</div>
            </div>
          </div>
          <div className="ifno relative h-[120px] cursor-pointer border border-gray-300 bg-white p-3 text-sm">
            <h4 className="text-sm font-bold">Stylus AI</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StylusAiItem;
